export default "__VITE_ASSET__f7d63d5f__"